import { IndexForms } from "@hex-insights/app-modules";
import { Form } from "@hex-insights/forms";
import * as NewsletterFilterFormValues from "../form-values";
import * as Field from "./Field";

export function StandardFilters({
	formState,
}: IndexForms.StandardFiltersProps<NewsletterFilterFormValues.FilterFormValues>) {
	return (
		<Form.Column>
			<Field.Status formState={formState} />
			<Field.AuthorIDIn formState={formState} />
			<Field.SharedUserIDsIn formState={formState} />
		</Form.Column>
	);
}
